import React, { useState } from 'react';
import { signInApi } from '../api/user';
import { ACCESS_TOKEN, REFRESH_TOKEN } from "../utils/constants";

const LoginForm = () => {
  // Estado para almacenar el correo electrónico y la contraseña
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  // Función para manejar el envío del formulario
  const handleSubmit = async (e) => {
    e.preventDefault();

    const user = {
      email: username,
      password: password
    }
    const result = await signInApi(user);

    if (result.message){
      console.log(result.message);
      setError(result.message);
    }else{

      console.log(ACCESS_TOKEN);
      if (ACCESS_TOKEN === undefined){
        setError("Error al encontrar el usuario");
        console.log("Error al encontrar el usuario");
      }else{

        const { accessToken, refreshToken } = result;
        localStorage.setItem(ACCESS_TOKEN, accessToken);
        localStorage.setItem(REFRESH_TOKEN, refreshToken);

        setUsername('');
        setPassword('');
        setError('');
        // navigate(url)
        window.location.href = "/";
      }
    }



  };

  return (
    <div className='login'>
      <h2>Acceso a usuario</h2>
      <form onSubmit={handleSubmit}>
        {/* Campo de entrada para el nombre de usuario */}
        <label>
          Email:
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </label>
        <br />
        {/* Campo de entrada para la contraseña */}
        <label>
          Password:
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>
        <br />
        {/* Mostrar un mensaje de error si las credenciales son incorrectas */}
        {error && <div className="error-message">{error}</div>}
        {/* Botón de enviar */}
        <button className='button3' type="submit">Ingresar</button>
      </form>
    </div>
  );
};

export default LoginForm;
